/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'TestReceivedOrder',
    path: '/test-in/received-order',
    component: () =>
      import(
        /* webpackChunkName: "TestReceivedOrder" */ '@/views/testIn/received-order'
      ),
    meta: { title: '司机接单' },
  },
];
